import sanityClient from "@sanity/client";

export default sanityClient ({
    projectId: "2ljchaf6",
    dataset: "production"
})